import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import FormSection from "../../../../../../common/components/functional/formSection/FormSection";
import TesPricingOverride from "../../../../../tesPricingOverride/tesPricingOverrideUI/TesPricingOverride";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  PriceValueType,
  SingleOverrideItem,
} from "../../../../../tesPricingOverride/tesPricingOverrideAPI";
import { SupplementPriceOverride } from "../../../../../talents/talentAPI";
import { getTime } from "date-fns";

export const SupplementPricingOverrides = () => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const { tesId, supplementPriceOverrides, workStarts } = watch();
  const [salaryCategoryOpen, setSalaryCategoryOpen] = useState(false);
  const dateEpoch = useMemo(
    () => getTime(workStarts || new Date()),
    [workStarts],
  );

  const modalTitle = t(
    "tesPricingOverride:editTesPricingOverride",
  ).toUpperCase();
  const modalItemSelectLabel = t("tesPricingOverride:selectItem");
  const modalItemValueLabel = t("tesPricingOverride:selectValueLabel");

  const updateSupplementPriceOverrides = (item: SingleOverrideItem) => {
    const { key, value, unit } = item;

    const updatedSupplementPriceOverrides: SupplementPriceOverride = {
      ...supplementPriceOverrides,
      [key]: {
        value,
        unit: unit as PriceValueType,
      },
    };

    return updatedSupplementPriceOverrides;
  };

  const updateFormValues = (
    updatedSupplementPriceOverrides: SupplementPriceOverride,
  ) =>
    setValue("supplementPriceOverrides", updatedSupplementPriceOverrides, {
      shouldDirty: true,
    });

  const onAdd = (item: SingleOverrideItem) => {
    const updatedSupplementPriceOverrides =
      updateSupplementPriceOverrides(item);
    updateFormValues(updatedSupplementPriceOverrides);
    return true;
  };

  const onEdit = (item: SingleOverrideItem) => {
    const updatedSupplementPriceOverrides =
      updateSupplementPriceOverrides(item);
    updateFormValues(updatedSupplementPriceOverrides);
    return true;
  };

  const onDelete = (key: string) => {
    const updatedSupplementPriceOverrides = { ...supplementPriceOverrides };
    delete updatedSupplementPriceOverrides[key];
    updateFormValues(updatedSupplementPriceOverrides);
  };

  return (
    <>
      <FormSection
        title={t("order:salaryCategoryValues")}
        collapse
        open={salaryCategoryOpen}
        toggleOpen={() => setSalaryCategoryOpen(!salaryCategoryOpen)}
      >
        <>
          <Grid item xs={3} />
          <Grid item xs={9}>
            <TesPricingOverride
              tesId={tesId}
              date={dateEpoch}
              tesPricingOverrideItems={supplementPriceOverrides || {}}
              isLoading={false}
              onEdit={onEdit}
              onAdd={onAdd}
              onDelete={onDelete}
              modalTitle={modalTitle}
              modalItemSelectLabel={modalItemSelectLabel}
              modalItemValueLabel={modalItemValueLabel}
              tableWidth="100%"
              editable
            />
          </Grid>
        </>
      </FormSection>
    </>
  );
};
